import * as React from "react";
import { useLocation } from "react-router-dom";
import { AppRoute } from "../../../../navigation/routes";
import ManageClinician from "../ManageClinician/ManageClinician";
import Supervisees from "../Supervisees/Supervisees";
import { AclContext } from "../../../../contexts/AclContext";
import store from "../../../../store";
import { IClinician } from "intake_shared/src/types";
import { useState } from "react";
import RequestOfficeWindow from "../RequestOfficeWindow/RequestOfficeWindow";
import FindClinician from "../FindClinician/FindClinician";

export default function ClinicianWrapper() {
    const location = useLocation();
    const aclContext = React.useContext(AclContext);
    const [allSupervisees, setAllSupervisees] = React.useState<IClinician[]>([]);
    const [supervisorEmail] = useState(
        (
            (location.state || {}) as {
                supervisorEmail: string;
            }
        ).supervisorEmail
    );

    const isSuperviseesRoute =
        !location.pathname.endsWith(AppRoute.FIND_CLINICIAN) &&
        (location.pathname.endsWith(AppRoute.SUPERVISEES) ||
            location.pathname.endsWith(AppRoute.MANAGE_SUPERVISEE));

    // fetchSupervisees reads the whole clinicians collection, so only run it on
    // the one route that renders the result (not Find Clinician, Manage
    // Clinician or Request Office Window, which share this wrapper).
    React.useEffect(() => {
        if (!isSuperviseesRoute) {
            return;
        }
        const fetchSupervisees = async (emailToQuery) => {
            if (emailToQuery) {
                setAllSupervisees(await store.fetchSupervisees(emailToQuery));
            }
        };
        const emailToQuery = supervisorEmail || aclContext?.authUser.user?.email;
        fetchSupervisees(emailToQuery);
    }, [aclContext?.authUser.user?.email, supervisorEmail, isSuperviseesRoute]);

    if (location.pathname.endsWith(AppRoute.FIND_CLINICIAN)) {
        return <FindClinician />;
    } else if (isSuperviseesRoute) {
        return <Supervisees allSupervisees={allSupervisees} />;
    } else if (location.pathname.endsWith(AppRoute.REQUEST_OFFICE_WINDOW)) {
        return <RequestOfficeWindow />;
    } else {
        return <ManageClinician />;
    }
}
